export interface AppLanguage {
  code: string;
  flag: string;
  name: string;
}

export const APP_LANGUAGES: AppLanguage[] = [
  { code: 'en', flag: '🇬🇧', name: 'English' },
  { code: 'de', flag: '🇩🇪', name: 'Deutsch' },
];

export const SUPPORTED_LANGUAGE_CODES = new Set(APP_LANGUAGES.map((lang) => lang.code));

export function isLanguageSupported(code: string): boolean {
  return SUPPORTED_LANGUAGE_CODES.has(code);
}

export function getDefaultLanguage(): string {
  return 'en';
}

export function getLanguageByCode(code: string): AppLanguage | undefined {
  return APP_LANGUAGES.find((lang) => lang.code === code);
}
